<app-ngb-table
  class="mainTable"
  [scrollX]="true"
  [table]="table()"
  [showFooter]="true"
></app-ngb-table>
